module.exports = __webpack_public_path__ + "static/media/icon_sakurabc9ee521e89f3c250703b65937d1b9aa.webp";